import { VBtnToggle, VBtn} from 'vuetify/lib'
import styles from './index.module.less'
export default {
    props: {
        list : {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: () => ''
        },
        borderless: {
            type: Boolean,
            default: () => false
        },
        dense: {
            type: Boolean,
            default: () => false
        },
        activeClass: {
            type: String,
            default: () => styles['selected-btn']
        }
        // selected-btn
    },
    data() {
        return {
            myValue: this.value
        }
    },
    watch: {
        value(val) {
            this.myValue = val
        },
        myValue(val) {
            this.$emit('input', val)
        }
    },
    render() {
        const _this = this
        return <VBtnToggle
                    v-model={_this.myValue}
                    borderless={_this.borderless}
                    dense= {_this.dense}
                    active-class={_this.activeClass}
                    on = {
                        {
                            change:(val) => {
                                _this.$emit('change', val)
                            }
                        }
                    }
                >
                    {_this.list.map(item => {
                        return <VBtn value={item.value}>
                            <span>{item.label}</span>
                            </VBtn>
                    })}
            </VBtnToggle>
    }
}